<template>
    <input type="hidden" name="_token" :value="token">
</template>

<script>
const TOKEN = document.head.querySelector('meta[name="csrf-token"]');

export default {
    data: () => ({
        token: TOKEN.content || '',
    }),
}
</script>
